export const RESULT_OK = 0;
export const RESULT_INVALID_JSON_INPUT = 1;
export const RESULT_COMMAND_TYPE_MISSING = 2;
export const RESULT_PARAMETER_VALIDATION_FAILED = 3;
export const RESULT_UNKNOWN_COMMAND = 4;
export const RESULT_CLIENT_CONNECTION_REJECTED = 10;
export const RESULT_CLIENT_NOT_LOGGED_IN = 11;
export const RESULT_CLIENT_SESSION_NOT_INITIALIZED = 12;
export const RESULT_INVALID_LICENSE = 20;
export const RESULT_INVALID_LICENSE_IDENTIFICATION_KEYS = 21;
export const RESULT_ANOTHER_UPDATE_RUNNING = 31;
export const RESULT_LOGIN_FAILED = 100;
export const RESULT_LOGOUT_FAILED = 101;
export const RESULT_USER_ALREADY_LOGGED_IN = 102;
export const RESULT_DUPLICATE_NAME = 103;
export const RESULT_INVALID_EMAIL = 104;
export const RESULT_ITEM_NOT_FOUND = 105;
export const RESULT_USER_CHANGE_PASSWORD_FAILED = 107;
export const RESULT_DATABASE_AUTOLOGIN_FAILED = 108;
export const RESULT_BARCODE_NOT_FOUND = 109;
export const RESULT_INVALID_DATABASE_NAME = 110;
export const RESULT_REDLIKE_DATA_NOT_AVAILABLE = 111;
export const RESULT_DATABASE_UPDATE_NEEDED = 113;
export const RESULT_DATABASE_CANNOT_BE_USED = 114;
export const RESULT_CANNOT_CONNECT_TO_SERVER = 121;
export const RESULT_BARCODE_EXISTS = 127;
export const RESULT_INVALID_COLORANT = 128;
export const RESULT_MALFORMED_FORMULA = 134;
export const RESULT_CUSTOMER_NOT_FOUND = 136;
export const RESULT_EMPTY_STOCK = 139;
export const RESULT_ORDER_HAS_ALREADY_BEEN_ACQUIRED = 140;
export const RESULT_UNKNOWN_ERROR = 999;
export const RESULT_IMPORT_GENERIC = 200;
export const RESULT_IMPORT_FILE_MISSING = 201;
export const RESULT_IMPORT_DATA_MISSING = 202;
export const RESULT_IMPORT_UNKNOWN_FORMAT = 203;
export const RESULT_IMPORT_ABORTED = 204;
export const RESULT_IMPORT_UNDER_PROGRESS = 205;
export const RESULT_IMPORT_HEADER_MISSING = 206;
export const RESULT_TMC_NOT_AVAILABLE = 207;
export const RESULT_TMC_NOT_CONNECTED = 208;
export const RESULT_MAX_FILE_SIZE_EXCEEDED = 220;

export const MATCHING_RESULT_INVALID_PRODUCT = "M1";
export const MATCHING_RESULT_INVALID_BIP = "M2";
export const MATCHING_RESULT_INVALID_BIPP = "M3";
export const MATCHING_RESULT_INVALID_COLOR_FILE = "M4";
export const MATCHING_RESULT_INVALID_SPECTRAL_CURVE = "M5";
export const MATCHING_RESULT_NO_COLOR_FILES_FOR_PRODUCT = "M6";
export const MATCHING_RESULT_INVALID_CNT_ID = "M7";
export const MATCHING_RESULT_INVALID_CNT_NAME = "M8";
export const MATCHING_RESULT_CORRECTION_NOT_POSSIBLE = "M9";
export const MATCHING_RESULT_INVALID_ILLUMINANT = "M10";
export const MATCHING_RESULT_REFORMULATION_NOT_POSSIBLE = "M11";
export const MATCHING_RESULT_UNKNOWN_ERROR = "M999";
export const MATCHING_RESULT_DATACOLOR_MATCHING_DISABLED = "M1001";
export const MATCHING_RESULT_DATACOLOR_MATCHING_OFFLINE = "M1002";
export const MATCHING_RESULT_DATACOLOR_INVALID_CREDENTIALS = "M1003";
export const MATCHING_RESULT_DATACOLOR_NO_CANS_AVAILABLE = "M1004";
export const MATCHING_RESULT_NOT_AUTHORIZED = "M401";
export const MATCHING_RESULT_FORBIDDEN = "M403";
export const MATCHING_RESULT_NOT_FOUND = "M404";
export const MATCHING_RESULT_VALIDATION_ERROR_WITH_DESCRIPTION = "M422";
export const MATCHING_RESULT_INTERNAL_SERVER_ERROR = "M500";
export const MATCHING_RESULT_DATACOLOR_INTERNAL_ERROR = "M1999";

export const RCC_RESULT_OK = 0;
export const RCC_RESULT_JSON_INPUT = 1;
export const RCC_RESULT_ABORTED = 2;
export const RCC_RESULT_COMMAND_TYPE_MISSING = 3;
export const RCC_RESULT_PARAMETER_VALIDATION_FAILED = 4;
export const RCC_RESULT_UNKNOWN_COMMAND = 5;
export const RCC_RESULT_FORMULA_COLORANT_MISSING = 10;
export const RCC_RESULT_FORMULA_CHANNEL_MISSING = 11;
export const RCC_RESULT_PRINTING_ERROR = 12;
export const RCC_RESULT_INVALID_LICENSE = 20;
export const RCC_RESULT_AUTOTASK_DUPLICATE_NAME = 30;
export const RCC_RESULT_UNKNOWN_ERROR = 999;

export const HELPER_RESULT_OK = 0;
export const HELPER_RESULT_JSON_DECODE = 1;
export const HELPER_RESULT_JSON_ENCODE = 2;
export const HELPER_RESULT_COMMAND_TYPE_MISSING = 3;
export const HELPER_RESULT_PARAMETER_VALIDATION_FAILED = 4;
export const HELPER_RESULT_UNKNOWN_COMMAND = 5;
export const HELPER_RESULT_UNKNOWN_ERROR = 99;

export const ERROR_INTEGRITY = "IntegrityError";

export const FT_UNKNOWN_VERSION = 1;
export const FT_INVALID_FILE = 2;

export const FT_IN_FILE_NOT_PROVIDED = 1;
export const FT_IN_INVALID_FILE = 2;
export const FT_IN_UNKNOWN_VERSION = 3;
export const FT_IN_CUSTOMER_ERROR = 101;
export const FT_IN_CUSTOM_FORMULA_ERROR = 102;
export const FT_IN_ORDER_ERROR = 103;

export const FT_OUT_NO_DATA = 1;
export const FT_OUT_INVALID_ITEM = 2;
